/// <amd-module name="Pipeline/Analytics/PipelineOutcome/FailureTrendCard/Sources/PipelineOutcomeFailureTrendSource" />
import { IReportContext } from "Analytics/Shared/Common/Types";
import { ITrendChartData, ITrendChartReportConfiguration } from "Analytics/Shared/TrendChart/Common/Types";
import { ITopFailingStageAndTaskData } from "Pipeline/Analytics/Common/Types";
import { PipelineOutcomeReportSource } from "Pipeline/Analytics/PipelineOutcome/Common/Sources/PipelineOutcomeReportSource";
import { IVssPageContext } from "VSS/Platform/Context";

export class PipelineOutcomeFailureTrendSource extends PipelineOutcomeReportSource {
    constructor(pageContext: IVssPageContext) {
        super("PipelineAnalytics_PipelineOutcomeFailureTrend", pageContext);
    }

    public queryFailingStageAndTaskData(
        reportContext: IReportContext,
        confValues: ITrendChartReportConfiguration
    ): Promise<ITopFailingStageAndTaskData> {
        return this.getTopFailingStageAndTaskData(reportContext, confValues);
    }
}
